export const isSafeText = (text) => {
    // Return empty string for null/undefined text
    if (!text) return { safe: true, triggers: [] }
    
    // Define all patterns with their names and regex
    const patterns = [
        { name: 'htmlTag', pattern: /<[^>]*>|<\/[^>]*>|&[#a-zA-Z0-9]+;/g },
        { name: 'script', pattern: /<script[^>]*>[\s\S]*?<\/script>/gi },
        { name: 'onEvent', pattern: / on\w+=/gi },
        { name: 'dataAttribute', pattern: / data-[\w\-]+=(?:'|")([^'"]*?)(?:'|")/gi },
        { name: 'iframe', pattern: /<iframe[^>]*>[\s\S]*?<\/iframe>/gi },
        { name: 'imgWithScript', pattern: /<img[^>]*\sonerror=[^>]*>/gi },
        { name: 'javascript', pattern: /javascript\s*:/gi },
        { name: 'otherScriptProtocols', pattern: /\b(vbscript|data|expression|mocha)\s*:/gi },
        { name: 'sqlInjection', pattern: /\b(SELECT|INSERT|UPDATE|DELETE|DROP|ALTER|EXEC|TRUNCATE|DECLARE)\b|--[\s\n]|;\s*--\s*|\)\s*;\s*[\S\s]*--\s*/gi },
        { name: 'encodedJavascript', pattern: /(%0[Aa]|\\u00[Aa][Aa]|\\x0[Aa])(%[Jj]|j)((%0[Aa]|\\u00[Aa][Aa]|\\x0[Aa])|a)(%[Vv]|v)((%0[Aa]|\\u00[Aa][Aa]|\\x0[Aa])|a)(%[Ss]|s)(%[Cc]|c)(%[Rr]|r)(%[Ii]|i)(%[Pp]|p)(%[Tt]|t)/gi },
        { name: 'cssExpression', pattern: /expression\s*\([\s\S]*\)/gi },
        { name: 'phpInjection', pattern: /<\?php|\?>/gi },
        { name: 'base64Suspicious', pattern: /base64[^\w\d]+([\-A-Za-z0-9+/]{20,})[=]{0,2}/gi }
    ]
    
    // Test each pattern individually and collect triggers
    const triggers = []
    
    for (const { name, pattern } of patterns) {
        // Need to reset the lastIndex property for regex with global flag
        pattern.lastIndex = 0
        if (pattern.test(text)) {
            triggers.push(name)
        }
    }
    
    // Return result object with safety status and triggers
    return {
        safe: triggers.length === 0,
        triggers: triggers
    }
}